// extracted by mini-css-extract-plugin
export default {"btn":"BtnNavigate_btn__jvp99"};